var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NavBar',{attrs:{"isShowLeft":false}},[_c('template',{slot:"left"},[_c('van-icon',{attrs:{"name":"arrow-left"},on:{"click":_vm.handleBack}})],1),_c('template',{slot:"content"},[_c('div',[_vm._v(_vm._s(_vm.productInfo.productName))])])],2),(_vm.productInfo.productName)?_c('Recording'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }